import Crud from '../views/DispatchReason/Crud'
import Entity from '../views/DispatchReason/Add'

let routes = {
    path: '/dispatch_reasons',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/dispatch_reasons/add',
            name: 'NewDispatchReason',
            component: Entity,
            meta: {
                pageTitle: 'dispatchReason.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'dispatchReason.form.newTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/dispatch_reasons/edit/:id?',
            name: 'EditDispatchReason',
            component: Entity,
            meta: {
                pageTitle: 'dispatchReason.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'dispatchReason.form.editTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/dispatch_reasons',
            name: 'list-dispatch-reasons',
            component: Crud,
            meta: {
                pageTitle: 'dispatchReason.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'dispatchReason.crud.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
